import { api } from "@/api/client";

// Real-time keyless portfolio surface (founder-gated, fail-closed 403).
export const wealthApi = {
  portfolio: () => api.get("/wealth-money/portfolio").then((r) => r.data),
  // Mortgage Blueprint persistence (per-user, authenticated)
  saveBlueprint: (payload) => api.post("/wealth/mortgage-blueprint", payload).then((r) => r.data),
  listBlueprints: () => api.get("/wealth/mortgage-blueprints").then((r) => r.data),
  deleteBlueprint: (id) => api.delete(`/wealth/mortgage-blueprint/${id}`).then((r) => r.data),
};
